import actionTypes from 'constants/actionTypes'

interface FocusState {
  id: string
}

interface FocusAction {
  type: string
  payload?: {
    id?: string
  }
}

const initialState: FocusState = {
  id: '',
}

const focus = (state: FocusState = initialState, action: FocusAction): FocusState => {
  switch (action.type) {
    case actionTypes.GRAPH.FOCUS:
      return {
        id: action.payload?.id ?? ''
      }
    case actionTypes.GRAPH.UNFOCUS:
      return {
        id: ''
      }
    default:
      return state
  }
}

export default focus
